<template>
    <app-modal>
        <el-card class="box-card" >
            <h2>Arrastra los items arriba / abajo para ordenar</h2>
            <hr>
            <draggable v-model="items">
                <transition-group name="list-complete">
                    <div class="item" v-for="element in items" :key="element.id" v-if="element.id != 0"> {{ element[name] }} <hr /></div>
                </transition-group>
            </draggable>
            <el-button @click="update">Guardar</el-button>
        </el-card>
    </app-modal>
</template>
<script>
	import ApiService from "@/common/api.service";
	import { API_UPLOADS } from "@/common/config";
    import Modal from '@/components/Dashboard/Modals/modal'
    import draggable from 'vuedraggable'

    export default {
        name: "modalDraggable",
        props: ['content', 'name', 'table'],
        components: {
            'app-modal': Modal,
            draggable
		},
        created () {
            let order = this.order
            this.items =  [
                {
                    id: 0,
                    order: 0,
                }
            ]
            this.content.forEach(element => {
                this.items.push(element)
            });
        },
        data() {
            return {
                btn: 'Guardar',
                items: null,
                show: false,
                order: 'order_row'
            }
        },
        methods: {
            closeModal(){
                this.$root.$emit('closeModal')
            },
            update() {
                this.items.forEach( (element, index) => {
                    if(element.id != 0){
                        ApiService.post("public/v1", {
                            token: localStorage.getItem("analiticatoken"),
                            single: true,
                            method: 'UPDATE',
                            id: element.id,
                            table: 'informes',
                            form: {order_row: index}
                        }).then(response => {
                            this.$root.$emit('msgSuccess', 'Registro insertado')
                        })
                    }
                })
                setTimeout(() => {
                    this.closeModal()
                }, 100);
            },
        }
    }
</script>

<style scoped>
    .item {
        font-size: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Modals/draggable.vue